import Carousel from '../components/product-carousel';
import { docReady } from '../utils/docReady';
// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
docReady(() => {
    const sections = document.querySelectorAll('[data-section-type="product-carousel"]');
    if (sections.length > 0) {
        [...sections].forEach((section) => {
            const { desktopCount, mobileCount, sectionId } = section.dataset;
            const slides = parseInt(section.dataset.tiles, 10);
            if (slides > 1) {
                const swiperContainer = section.querySelector('[data-swiper-container]');
                const swiperNext = `[data-section-id="${sectionId}"] .swiper-button-next`;
                const swiperPrev = `[data-section-id="${sectionId}"] .swiper-button-prev`;
                const carousel = new Carousel(swiperContainer, slides, swiperNext, swiperPrev, Number(desktopCount), Number(mobileCount), {
                    loop: true,
                    centeredSlides: true,
                });
            }
        });
    }
});
